import { API_PRECOG_URL_V1 } from "../../../config";
import { callWithRetry } from "../../services/callWithRetry";
import { createHttpHeaderWithAuthorization } from "../../services/http-header";

export const precogHighlightsWidgetConstants = {
  GET_HIGHTLIGHTS_COUNTER_START: "GET_HIGHTLIGHTS_COUNTER_START",
  GET_HIGHTLIGHTS_COUNTER_SUCCESS: "GET_HIGHTLIGHTS_COUNTER_SUCCESS",
  GET_HIGHTLIGHTS_COUNTER_ERROR: "GET_HIGHTLIGHTS_COUNTER_ERROR"
};

export function highlightsCounter() {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;    
    return new Promise((resolve, reject) => {
      dispatch({
        type: precogHighlightsWidgetConstants.GET_HIGHTLIGHTS_COUNTER_START
      });
      let request = {
        method: "GET",
        url: `${API_PRECOG_URL_V1}/precog/widget/highlights?managerId=${managerId}&itemId=${itemId}`,
        headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)       
      };
      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: precogHighlightsWidgetConstants.GET_HIGHTLIGHTS_COUNTER_SUCCESS,
              payload: result.data
            });
            resolve(result.data);
          } else {
            dispatch({
              type: precogHighlightsWidgetConstants.GET_HIGHTLIGHTS_COUNTER_ERROR
            });
            reject();
          }
        })
        .catch((response) => {
          dispatch({
            type: precogHighlightsWidgetConstants.GET_HIGHTLIGHTS_COUNTER_ERROR
          });
          reject();
        });
    });
  };
}